module.exports = __webpack_public_path__ + "static/media/tik-tok.bbaabf1a.png";